import { render, staticRenderFns } from "./Transshipment.vue?vue&type=template&id=ca8f2604&scoped=true"
import script from "./Transshipment.vue?vue&type=script&lang=js"
export * from "./Transshipment.vue?vue&type=script&lang=js"
import style0 from "./Transshipment.vue?vue&type=style&index=0&id=ca8f2604&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8f2604",
  null
  
)

export default component.exports